import { render, staticRenderFns } from "./CommentableDocument.vue?vue&type=template&id=1b66f271&"
import script from "./CommentableDocument.vue?vue&type=script&lang=ts&"
export * from "./CommentableDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports